import { render, staticRenderFns } from "./ManningVesselsList.vue?vue&type=template&id=6f54fa4d"
import script from "./ManningVesselsList.vue?vue&type=script&lang=js"
export * from "./ManningVesselsList.vue?vue&type=script&lang=js"
import style0 from "./ManningVesselsList.vue?vue&type=style&index=0&id=6f54fa4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports